import { Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { isStartDateAfterTargetDate } from '@acorn-portal/shared/src/utils/index';
import { parseISO } from 'date-fns';
import { KeyCareUnderwriter } from '../services/interface/Shared';

export const ANNUAL_MILEAGE = {
	header: 'Annual Mileage',
	text: 'What is the approximate number of miles your vehicle will travel in the next 12 months. If you are unsure as to how many miles you drive, calculate how many miles you will do on an average week and any long journeys. Then multiply this by the number of weeks in a year.',
};

export const ANNUAL_MILEAGE_YD = {
	header: 'Annual Mileage',
	text: 'What is the approximate number of miles your vehicle will travel within the 12 months. If you are unsure as to how many miles you drive, calculate how many miles you will do on an average week and any long journeys. Then multiply this by the number of weeks in a year. Please note, the maximum amount of mileage we can offer in any one policy year is 30 thousand miles',
};

export const BUSINESS_MILEAGE = {
	header: 'Business Mileage',
	text: 'How much out of your declared annual mileage will you be using for business purposes?',
};

export const COVER_LEVEL = (startDate: string, product: Product) => {
	const targetDate = new Date('2024-07-01');
	const isTaxiOrCv = product === Product.TAXI || product === Product.COMMERCIAL_VEHICLE;
	const formattedStartDate = parseISO(startDate);
	return {
		header: 'Cover Level',
		text: `
  Third Party Fire and Theft – provides cover to a third party for unlimited injury and third party damage up to  ${
		isStartDateAfterTargetDate(formattedStartDate, targetDate) && isTaxiOrCv ? '2' : '20'
	} million plus cover for your own vehicle as a result of a fire claim or if your car is stolen. This excludes accidental damage and malicious damage to your vehicle.
  <br>
  <br>
  Comprehensive - provides cover to a third party for unlimited injury and third party damage up to ${
		isStartDateAfterTargetDate(formattedStartDate, targetDate) && isTaxiOrCv ? '2' : '20'
	} million, cover for your own vehicle as a result of a fire claim or if your car is stolen plus any accidental damage to your own car.
  `,
	};
};

export const COVER_LEVEL_RESTART = {
	header: 'Cover Level',
	text: `<span class="sub-paragraph">Third Party Fire and Theft – provides cover to a third party for unlimited injury and third party damage up to
	20 million plus cover for your own vehicle as a result of a fire claim or if your car is stolen. This excludes accidental damage and malicious damage to your vehicle.
  </span>
  <span class="sub-paragraph">
  Comprehensive - provides cover to a third party for unlimited injury and third party damage up to
	20 million, cover for your own vehicle as a result of a fire claim or if your car is stolen plus any accidental damage to your own car.</span>`,
};

export const COVER_LEVEL_UPDATED = (startDate: string, product: Product) => {
	const targetDate = new Date('2024-07-01');
	const formattedStartDate = parseISO(startDate);
	const isTaxiOrCv = product === Product.TAXI || product === Product.COMMERCIAL_VEHICLE;
	return {
		header: 'Cover Level',
		text: `
  Third Party Fire and Theft – provides cover to a third party for unlimited injury and third party damage up to ${
		isStartDateAfterTargetDate(formattedStartDate, targetDate) && isTaxiOrCv ? '2' : '20'
	}  million plus cover for your own vehicle as a result of a fire claim or if your car is stolen. This excludes accidental damage and malicious damage to your vehicle.
  <br>
  <br>
  Comprehensive - provides cover to a third party for unlimited injury and third party damage up to ${
		isStartDateAfterTargetDate(formattedStartDate, targetDate) && isTaxiOrCv ? '2' : '20'
	}  million, cover for your own vehicle as a result of a fire claim or if your car is stolen plus any accidental damage to your own car.
  <br>
  <br>
  Third Party Only - provides cover to a third party for unlimited injury and third party damage up to ${
		isStartDateAfterTargetDate(formattedStartDate, targetDate) && isTaxiOrCv ? '2' : '20'
	}  million, plus medical expenses for your passengers up to £100 each when injured in an incident (subject to a maximum of £400 per incident). This excludes cover for your own vehicle.
  `,
	};
};

export const VEHICLE_USED_FOR = {
	header: 'Vehicle Use',
	text: `<b>Social, domestic and pleasure (SDP)</b> - Excludes commuting, business use / hire & reward <br/>
    <b>Commuting</b> - Covers SDP & commuting to a single place of work or study. <br/>
    <b>Business Use</b> - Covers SDP & travel to multiple places of work, excluding for hire & reward. <br/>`,
};

export const UK_RESIDENCY_MODAL = {
	header: 'Date UK Residency Began',
	text: 'When your official UK residency began',
};

export const PAYMENT_PROBLEM_MODAL = {
	header: 'Payment Problem',
	text: `Unfortunately, there has been an issue with your payment. Please try again or give us a call <b><a href="tel:01704 339 983">01704 339 983</a></b> and we'll be happy to help.`,
};

export const VEHICLE_LEFT_HAND_DRIVE = {
	header: 'Vehicle Left Hand Drive',
	text: 'The UK standard is for a vehicle to be a right hand drive. When you enter a vehicle and you are facing the windscreen, you will find will the steering wheel on the right side.',
};

export const TAXI_VEHICLE_USE = {
	header: 'Vehicle Use',
	text: `<b>Private Hire</b> - Social, domestic and pleasure including commuting by the Insured to a permanent place of work. For the carriage of passengers or goods, including fast food delivery, for hire and reward by prior appointment only (private hire) provided such use complies with the laws and regulations of the appropriate licensing authority.
<br>
<br>
<b>Public Hire</b> - Social, domestic and pleasure including commuting by the Insured to a permanent place of work. For the carriage of passengers or goods, including fast food delivery, for hire and reward (private hire and / or hackney carriage/public hire) provided such use complies with the laws and regulations of the appropriate licensing authority.`,
};

export const BUSINESS_RADIUS = {
	header: 'Business Radius',
	text: 'Will the vehicle be used in a radius of up to 100 or over 100 miles from the address it is being kept at?',
};

export const COST_OF_CLAIM = {
	header: 'Cost of Claim',
	text: 'Please enter the total cost for the repairs to their vehicle, including third parties and any other vehicles involved. If they do not know the total cost of the claim, please enter £0. Please note, your premium may change once we determine the actual cost of the claim. We also have the right to refuse cover based on the actual cost.',
};

export const SPECIAL_TERMS = {
	header: 'Special Terms Imposed',
	text: 'Special Terms Imposed would be where an insurer offered cover but only with specific restrictions in place. This may include limiting the types of vehicles that can be driven, limiting the types of claims they will cover or requiring specific security devices fitted to the vehicle.',
};

export const CONVICTIONS = {
	header: 'Non-motoring Conviction',
	text: 'To check whether their criminal conviction is unspent, and for further help and guidance, please visit <a href="https://unlock.org.uk" target="_blank" rel="noreferrer">https://unlock.org.uk</a>',
};

export const DANGEROUS_GOODS = {
	header: 'Dangerous Goods',
	text: 'Dangerous goods are any goods that pose a risk to people, property, and the environment. For example, explosives, flammables, fuming acids, solvents, pesticides.',
};

export const VOLUNTARY_EXCESS_MODAL = {
	header: 'Voluntary Excess',
	text: `An excess is the amount of money you will pay towards the cost of your claim. There are two types of excess, Compulsory Excess and Voluntary excess.
<br>
<br>
  The Compulsory Excess is set by the insurer, whilst the Voluntary Excess is set by you. The two added together make up the total excess and this is the total amount you would pay towards any claim. For example, if the Compulsory Excess was set at £100 and the Voluntary Excess was also set at £100, you would have a total excess of £200; this is the amount you would have to pay in the event of a claim.
  <br>
  <br>
  This question allows you to set the Voluntary Excess. Generally, the higher you set this figure, the lower your potential premium. This is because the insurer will have less to pay out should you make a claim. Please note that you can amend this figure when you reach the results page if you need to change it.`,
};

export const TELEMATICS_TOP_UP_MILES_HELP_TEXT = (mileage: number) =>
	`You can only increase your mileage, not decrease it. The selected value cannot be lower than your current annual mileage${mileage ? ` of ${mileage} miles.` : '.'}`;

export const TELEMATICS_ANNUAL_MILEAGE_HELP_TEXT =
	'Your mileage is monitored as part of your policy terms and conditions and if you exceed your annual mileage, you may be at risk of your policy being cancelled.';

export const CHECK_MILEAGE_THINGCO_TEXT =
	'Before you top up your miles, make sure you will have enough to cover you for the remainder of your policy, you can estimate how many you need by using our mileage calculator tool or checking what your predicted mileage is on your Better Driver App.';
export const CHECK_MILEAGE_IMS_TEXT =
	'Before you top up your miles, make sure you will have enough to cover you for the remainder of your policy, you can estimate how many you need by using our mileage calculator tool.';

export const TERMS_MODAL = {
	title: 'Direct Debit Terms and Conditions',
	description: `<p>The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits
    <p/>
   <p> If there are any changes to the amount, date or frequency of your Direct Debit Acorn Insurance & Financial services will notify you (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you request the Acorn Insurance & Financial services to collect a payment, confirmation of the amount and date will be given to you at the time of the request
    <p/>
    <p>If an error is made in the payment of your Direct Debit, by Acorn Insurance & Financial services or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society. If you receive a refund you are not entitled to, you must pay it back when Acorn Insurance & Financial services asks you to
    <p/>
   <p> You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify the organisation.</p>`,
};

export const SUCCESS_MODAL = {
	title: 'Your Change Has Been Successful',
	description: `<p>Your policy documents have been updated. It is important you take the time to carefully read this information
  <p/>`,
};

export const PAYMENT_DATE_CHANGE_RESTRICTION_MODAL = {
	title: 'Payment Date Change:',
	description:
		'Your payment date cannot be changed more than once per policy term. Please contact us on (https://www.granitefinance.co.uk/), or call  01704 339 500 to view available payment options',
};

export const BANK_DETAILS_CHANGE_RESTRICTION_MODAL = {
	title: 'Change of Bank Details:',
	description:
		'Your payment details cannot be changed more than once per policy term. Please contact us on  link(https://www.granitefinance.co.uk/) , or call 01704 339 500 to view available payment options',
};

export const REGISTRATION_POLICY_NUMBER_MODAL = {
	title: 'Policy Number Information',
	description:
		'Please enter the policy number of your current insurance policy with us. This can be found in the policy documents we have sent to you.',
};

export const REGISTRATION_POST_CODE_MODAL = {
	title: 'Postcode Information',
	description:
		"The postcode should correspond to the policy holder's address, not the location where the vehicle is stored overnight. Please ensure this is a UK postcode and entered in the standard UK format. For example, 'SW1A 1AA'.",
};

export const REGISTRATION_VEHICLE_REGISTRATION_MODAL = {
	title: 'Vehicle Registration Information',
	description:
		'This should be the registration number of the vehicle for which you have purchased cover with us. Ensure that the registration number is entered accurately to prevent any issues registering.',
};

export const OVERNIGHT_ADDRESS_DIFFERENT = {
	title: 'Kept Overnight',
	description:
		'Please declare where your vehicle is kept overnight. If your vehicle is kept at two or more locations, please state where it is kept most of the time.',
};

export const LICENCE_OBTAINED_MODAL = {
	header: 'Licence Obtained Date',
	text: 'This can be found on the front of their driving licence, the date of issue (4a), expiry (4b), issuing authority (4c)',
};

export const LEGAL_COVER_MODAL = {
	header: 'Legal Cover (Additional Benefits)',
	text: `
  <br>
  Provides cover to help you claim back uninsured losses from the responsible party if your car is damaged in an incident that is not your fault. This may include your excess, hire vehicle costs, alternative travel costs or compensation for property damage.
  <br>
  <br>
  <b>What it covers</b>
  <br>
  Up to £50,000 to pursue a covered claim
  <br>
  Cover if there is a greater than 51% chance of success
  <br>
  <br>
  <b>What it doesn't cover</b>
  <br>
  Claims covered by another insurance policy
  <br>
  Fines, penalties or compensation awarded against you
  <br>
  <br>
  Please refer to the Policy Booklet and Insurance Product Information Document for full terms and conditions
  `,
};

export const WINDSCREEN_COVER_MODAL = {
	header: 'Windscreen Cover (Additional Benefits)',
	text: `Provides cover towards the costs of repairing the car's windscreen or replacement, if repairs are not possible.
  <br>
  <br>
  <b>What is covered</b>
  <br>
  Unlimited claims during the policy period
  <br>
  Claims will not affect your no claims discount
  <br>
  £25 excess payable for a repair with an approved repairer
  <br>
  £115 excess payable for a replacement with an approved repairer
  <br>
  Cover up to £50 for repair or replacement with a non-approved repairer
  <br>
  <br>
  <b>What is not covered</b>
  <br>
  Sunroof cover
  <br>
  Cover for windows not made of glass
  <br>
  <br>
  Please refer to the Policy Booklet and Insurance Product Information Document for full terms and conditions.
  `,
};

export const ESTIMATED_VALUE_MODAL = {
	header: 'Vehicle Value',
	text: 'By Market value of your car, we mean how much it would cost to replace your car with one that’s the similar make, model, specification, age, mileage and condition. Just to let you know, in the event your vehicle is declared a Total Loss as a result of an accident/incident covered by this insurance, we will make a payment to the owner of the vehicle. The payment will be based on the market value of the vehicle at time of claim.',
};

export const FLAG_TAXI_REPLACEMENT_HIRE = {
	text: `This product provides the customer with a Licenced Taxi Vehicle, for either 14 or 21 days, if their own vehicle is lost or damaged following an insured incident.
  The product meets the demands and needs of a customer who requires guaranteed access to a Licenced Taxi Vehicle following an incident.
        <br>
        <br>
        Key exclusions:
        <ul>
          <li>
          Any additional charges from the replacement hire vehicle company other than the cost of the replacement hire vehicle
          </li>
          <li>
          More than 2 claims during any one period of insurance
          </li>
        </ul>
        <a href="https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/IPID-Taxi-Hire-Cover.pdf" target="_blank" rel="noreferrer">Taxi Hire Cover IPID</a>
        <br>
        <a href="https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/Haven-Insurance-Policy-Booklet-Taxi-Hire-Cover.pdf" target="_blank" rel="noreferrer">Taxi Hire Cover Booklet</a>
        `,
};

export const TAXI_REPLACEMENT_HIRE = {
	text: `This product provides the customer with a Licenced Taxi Vehicle, for either 14 or 21 days, if their own vehicle is lost or damaged following an insured incident.
  The product meets the demands and needs of a customer who requires guaranteed access to a Licenced Taxi Vehicle following an incident.
        <br>
        <br>
        Key exclusions:
        <ul>
          <li>
          Any additional charges from the replacement hire vehicle company other than the cost of the replacement hire vehicle
          </li>
          <li>
          More than 2 claims during any one period of insurance
          </li>
        </ul>
        <a href="https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/IPID-Taxi-Hire-Cover.pdf" target="_blank" rel="noreferrer">Taxi Hire Cover IPID</a>
        <br>
        <a href="https://haven.gi/docs/Add-Ons/Guarenteed-Taxi-Hire/Haven-Insurance-Policy-Booklet-Taxi-Hire-Cover.pdf" target="_blank" rel="noreferrer">Taxi Hire Cover Booklet</a>
        `,
};

export const KEYCARE_COVER_MODAL = (underwriter: KeyCareUnderwriter) => {
	return {
		header: 'Keycare Cover (Optional Extras)',
		text: `
    <br>
    This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or car keys, or the cost to retrieve them if locked in the car or home.
    <br>
    <br>
    <b>What it covers</b>
    <br>
    Theft of keys up to £1,500
    <br>
    Loss of keys up to £1,500
    <br>
    £0 maximum excess per claim
    <br>
    Claims will not affect your no claims discount
    <br>
    The cost of locksmith services
    <br>
    Replacement locks
    <br>
    Replacement keys
    <br>
    Provided by ${underwriter}
    <br>
    <br>
    <b>What it doesn't cover</b>
    <br>
    Keys left in the car or left unattended
    `,
	};
};

export const KEY_CARE = (underwriter: KeyCareUnderwriter) => {
	const documentLinks = `<a href="https://haven.gi/docs/Add-Ons/Keycare/IPID-Acorn-Keycare.pdf" target="_blank" rel="noreferrer">Key Care Cover IPID</a><br/><a href="https://haven.gi/docs/Add-Ons/Keycare/Keycare-Brochure.pdf" target="_blank" rel="noreferrer">Key Care Cover Booklet</a>`;
	return {
		text: `This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or vehicle keys, or the cost to retrieve them if locked in the vehicle or home.
        <br>
        <br>
        This is a key insurance policy. It provides insurance cover for lost and stolen keys, broken keys and you also have cover if you lock your keys in your home or vehicle and require a locksmith to gain entry.
        <br>
        <br>
        Provided by ${underwriter}, please refer to the Insurance Product Information Document for full terms and conditions.
        <br>
        <br>
        Key exclusions:
                      <ul>
                        <li>
                          Keys which are not attached to the Key Fob at the time of the loss
                        </li>
                        <li>
                          Keys lost by someone other than the policyholder, or a member of
                          their immediate family living at the same address, or an
                          authorised employee (if the policyholder is a company)
                        </li>
                        <li>
                          Wear and tear and/or general maintenance of keys and locks
                        </li>
                      </ul>
        ${documentLinks}
        `,
	};
};
export const KEY_CARE_FLAG = (underwriter: KeyCareUnderwriter) => {
	const documentLinks = `<a href="https://haven.gi/docs/Add-Ons/Keycare/IPID-Flag-Keycare.pdf" target="_blank" rel="noreferrer">Key Care Cover IPID</a><br/><a href="https://haven.gi/docs/Add-Ons/Keycare/Flag-Keycare-Policy-Booklet.pdf" target="_blank" rel="noreferrer">Key Care Cover Booklet</a>`;
	return {
		text: `This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or vehicle keys, or the cost to retrieve them if locked in the vehicle or home.
        <br>
        <br>
        This is a key insurance policy. It provides insurance cover for lost and stolen keys, broken keys and you also have cover if you lock your keys in your home or vehicle and require a locksmith to gain entry.
        <br>
        <br>
        Provided by ${underwriter}, please refer to the Insurance Product Information Document for full terms and conditions.
        <br>
        <br>
        Key exclusions:
                      <ul>
                        <li>
                          Keys which are not attached to the Key Fob at the time of the loss
                        </li>
                        <li>
                          Keys lost by someone other than the policyholder, or a member of
                          their immediate family living at the same address, or an
                          authorised employee (if the policyholder is a company)
                        </li>
                        <li>
                          Wear and tear and/or general maintenance of keys and locks
                        </li>
                      </ul>
        ${documentLinks}
        `,
	};
};
export const KEY_CARE_CARROT = (underwriter: KeyCareUnderwriter) => {
	const documentLinks = `<a href="https://www.carrotinsurance.com/docs/keycare/Keycare-IPID.pdf" target="_blank" rel="noreferrer">Key Care Cover IPID</a><br /><a href="https://www.carrotinsurance.com/docs/keycare/Keycare-Policy-Booklet.pdf" target="_blank" rel="noreferrer">Key Care Cover Policy Booklet</a>`;

	return {
		text: `This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or vehicle keys, or the cost to retrieve them if locked in the vehicle or home.
        <br>
        <br>
        This is a key insurance policy. It provides insurance cover for lost and stolen keys, broken keys and you also have cover if you lock your keys in your home or vehicle and require a locksmith to gain entry.
        <br>
        <br>
        Provided by ${underwriter}, please refer to the Insurance Product Information Document for full terms and conditions.
        <br>
        <br>
        Key exclusions:
                      <ul>
                        <li>
                          Keys which are not attached to the Key Fob at the time of the loss
                        </li>
                        <li>
                          Keys lost by someone other than the policyholder, or a member of
                          their immediate family living at the same address, or an
                          authorised employee (if the policyholder is a company)
                        </li>
                        <li>
                          Wear and tear and/or general maintenance of keys and locks
                        </li>
                      </ul>
        ${documentLinks}`,
	};
};
export const KEY_CARE_STREETCOVER = (underwriter: KeyCareUnderwriter) => {
	const documentLinks = `<a href="https://haven.gi/docs/Add-Ons/Keycare/IPID-Streetcover-Keycare.pdf" target="_blank" rel="noreferrer">Key Care Cover IPID</a><br/><a href="https://haven.gi/docs/Add-Ons/Keycare/Streetcover-Keycare-Policy-Booklet.pdf" target="_blank" rel="noreferrer">Key Care Cover Booklet</a>`;
	return {
		text: `This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or vehicle keys, or the cost to retrieve them if locked in the vehicle or home.
        <br>
        <br>
        This is a key insurance policy. It provides insurance cover for lost and stolen keys, broken keys and you also have cover if you lock your keys in your home or vehicle and require a locksmith to gain entry.
        <br>
        <br>
        Provided by ${underwriter}, please refer to the Insurance Product Information Document for full terms and conditions.
        <br>
        <br>
        Key exclusions:
                      <ul>
                        <li>
                          Keys which are not attached to the Key Fob at the time of the loss
                        </li>
                        <li>
                          Keys lost by someone other than the policyholder, or a member of
                          their immediate family living at the same address, or an
                          authorised employee (if the policyholder is a company)
                        </li>
                        <li>
                          Wear and tear and/or general maintenance of keys and locks
                        </li>
                      </ul>
        ${documentLinks}
        `,
	};
};

export const PUBLIC_LIABILITY_COVER_UP_10M = {
	text: `This product increases the level of Public Liability cover provided to the customer from a limit of £5 Million up to a limit of £10 Million. This price is based on the number of seats your vehicle is licensed to carry.
  <br/></br>This product meets the demands and needs of Taxi Drivers who require a larger Public Liability limit, particularly those who drive larger vehicles and may carry a larger number of passengers at any one time.<br/></br>
  <b>Key Exclusions</b>  <br/></br><ul><li>Loss or damage to you, your property of that of your employees</li></ul> <br/>

  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2019/04/Faraday-Taxi-Liability-Key-Facts.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Key Facts</a><br/>
  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2021/02/Faraday-Liability-Insurance-Policy-2021.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Booklet</a>
  `,
};

export const PUBLIC_LIABILITY_COVER_UP_10M_FLAG = {
	text: `This product increases the level of Public Liability cover provided to the customer from a limit of £5 Million up to a limit of £10 Million. This price is based on the number of seats your vehicle is licensed to carry.
  <br/></br>This product meets the demands and needs of Taxi Drivers who require a larger Public Liability limit, particularly those who drive larger vehicles and may carry a larger number of passengers at any one time.<br/></br>
  <b>Key Exclusions</b>  <br/></br><ul><li>Loss or damage to you, your property of that of your employees</li></ul> <br/>

  <a href="https://www.flaginsurance.co.uk/wp-content/uploads/2022/08/FaradayLiabilityInsurancePolicyKeyFactsDocument.pdf" target="_blank" rel="noreferrer">Public Liability Cover Key Facts</a><br/>
  <a href="https://www.flaginsurance.co.uk/wp-content/uploads/2022/08/FaradayLiabilityInsurancePolicy.pdf" target="_blank" rel="noreferrer">Public Liability Cover Booklet</a>
  `,
};

export const KEY_CARE_MOTORCADE = (underwriter: KeyCareUnderwriter) => {
	const documentLinks = `<a href="https://haven.gi/docs/Add-Ons/Keycare/IPID-Motorcade-Keycare.pdf" target="_blank" rel="noreferrer">Key Care Cover IPID</a><br/><a href="https://haven.gi/docs/Add-Ons/Keycare/Motorcade-Keycare-Policy-Booklet.pdf" target="_blank" rel="noreferrer">Key Care Cover Booklet</a>`;

	return {
		text: `This product meets the demands and needs of someone who requires cover for the cost if they lose, or have stolen, their home or vehicle keys, or the cost to retrieve them if locked in the vehicle or home.
        <br>
        <br>
        This is a key insurance policy. It provides insurance cover for lost and stolen keys, broken keys and you also have cover if you lock your keys in your home or vehicle and require a locksmith to gain entry.
        <br>
        <br>
        Provided by Keycare Limited and underwritten by ${underwriter}, please refer to the Insurance Product Information Document for full terms and conditions.
        <br>
        <br>
        Key exclusions:
                      <ul>
                        <li>
                          Keys which are not attached to the Key Fob at the time of the loss
                        </li>
                        <li>
                          Keys lost by someone other than the policyholder, or a member of
                          their immediate family living at the same address, or an
                          authorised employee (if the policyholder is a company)
                        </li>
                        <li>
                          Wear and tear and/or general maintenance of keys and locks
                        </li>
                      </ul>
       ${documentLinks}`,
	};
};

export const PUBLIC_LIABILITY_COVER_UP_5M_SHORT_TERM = {
	text: `Provides indemnity for legal ability to pay damages to third parties for injury or damage to their property up to £5 million.<br/><br/>
  <b>Key Exclusions</b><br/></br><ul><li>Loss or damage to you, your property of that of your employees</li></ul><br/>
  <b> For full terms and conditions please refer to your:</br>
  <br/>
  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2019/04/Faraday-Taxi-Liability-Key-Facts.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Key Facts</a><br/>
  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2021/02/Faraday-Liability-Insurance-Policy-2021.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Booklet</a>
    `,
};

export const PUBLIC_LIABILITY_COVER_UP_5M = {
	text: `This cover increases the level of Public Liability cover provided to the customer from the standard level included for a 5 seater vehicle, to cover for a 7 seater vehicle.<br/><br/>
  <b>Key Exclusions</b>  <br/></br><ul><li>Loss or damage to you, your property of that of your employees</li></ul> <br/>
  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2019/04/Faraday-Taxi-Liability-Key-Facts.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Key Facts</a><br/>
  <a href="https://www.acorninsure.co.uk/wp-content/uploads/2021/02/Faraday-Liability-Insurance-Policy-2021.pdf?gclid=EAIaIQobChMI0YvFppmRgQMVMYdQBh0mawJQEAAYAiAAEgKs5PD_BwE" target="_blank" rel="noreferrer">Public Liability Cover Booklet</a>
    `,
};

export const PUBLIC_LIABILITY_COVER_UP_5M_FLAG = {
	text: `This cover increases the level of Public Liability cover provided to the customer from the standard level included for a 5 seater vehicle, to cover for a 7 seater vehicle.<br/><br/>
  <b>Key Exclusions</b>  <br/></br><ul><li>Loss or damage to you, your property of that of your employees</li></ul> <br/>
  <a href="https://www.flaginsurance.co.uk/wp-content/uploads/2022/08/FaradayLiabilityInsurancePolicyKeyFactsDocument.pdf" target="_blank" rel="noreferrer">Public Liability Cover Key Facts</a><br/>
  <a href="https://www.flaginsurance.co.uk/wp-content/uploads/2022/08/FaradayLiabilityInsurancePolicy.pdf" target="_blank" rel="noreferrer">Public Liability Cover Booklet</a>
    `,
};
